import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconMouse: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} ariaLabel="mouse" maskId="round-filled-radius-1-stroke-1.5-IconMouse"><path fillRule="evenodd" clipRule="evenodd" d="M5 9C5 5.13401 8.13401 2 12 2C15.866 2 19 5.13401 19 9V15C19 18.866 15.866 22 12 22C8.13401 22 5 18.866 5 15V9ZM12.75 6.75C12.75 6.33579 12.4142 6 12 6C11.5858 6 11.25 6.33579 11.25 6.75V8.75C11.25 9.16421 11.5858 9.5 12 9.5C12.4142 9.5 12.75 9.16421 12.75 8.75V6.75Z" fill="currentColor"/></CentralIconBase>;
});

export default IconMouse;
